import ProhibitedItem from '../../components/layout/ITHeadquarters/prohibitedItem';

const ExceptionItemPage = () => {
    return <ProhibitedItem isException />;
};

export default ExceptionItemPage;
